<template>
  <section class="files-card">
    <div class="pdf-file fade-up" v-in-viewport.once>
      <div
        class="main-content"
        :class="_.get(data, 'files[1]') ? 'not-between' : ''"
      >
        <p class="font-16 title text-overflow-hidden-2">
          {{ data.title }}
        </p>
        <div class="file-info">
          <!-- <p class="font-13 date">{{ date }}</p> -->
          <template v-for="(item, index) in _.get(data, 'files')">
            <p
              class="font-13 download-title text-overflow-hidden-2"
              :key="index"
              @click="downloadItem(item)"
            >
              {{ item.title }}
            </p>
          </template>
        </div>
      </div>
      <div
        class="download-button pointer"
        v-if="!_.get(data, 'files[1]')"
        @click="downloadItem(_.get(data, 'files.0'))"
      >
        <IconComponent name="download-arrow" class="download" />
        <p class="font-16">
          {{ $fn.tr("Download") }}
        </p>
      </div>
    </div>
  </section>
</template>
<script>
import IconComponent from "../IconComponent.vue";
import moment from "moment";
import axios from "axios";

export default {
  props: ["data"],

  computed: {
    date() {
      return moment(this.data?.date).format("DD MMMM, YYYY");
    }
  },
  components: {
    IconComponent
  },
  methods: {
    downloadItem(val) {
      window.open(_.get(val, "url"), "_blank");
    }
    // downloadWithVueResource(download_file) {
    //   axios({
    //     url: _.get(download_file, 'url'),
    //     method: "GET",
    //     responseType: "blob"
    //   }).then(response => {
    //     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    //     var fileLink = document.createElement("a");

    //     fileLink.href = fileURL;
    //     fileLink.setAttribute("download", `${_.get(download_file, 'title')}.pdf`);
    //     document.body.appendChild(fileLink);

    //     fileLink.click();
    //   });
    // }
  }
};
</script>

<style lang="scss">
.files-card {
  .pdf-file {
    width: 100%;
    min-height: 300px;
    height: 100%;
    padding: 30px;
    overflow: hidden;
    background: var(--white-bg);
    border: 1px solid var(--white-txt);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .main-content {
      position: relative;
      padding-left: 19px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      min-height: 230px;
      &.not-between {
        justify-content: flex-start;
      }
      &::before {
        content: "";
        background: #dfdfdf;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        width: 2px;
        border-radius: 3px;
      }
      &::after {
        content: "";
        background: var(--red);
        max-height: 0;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        width: 2px;
        border-radius: 3px;
        transition: 0.4s ease-in-out;
      }
      .title {
        margin-bottom: 30px;
        min-height: 42px;
      }
      .file-info {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        height: 100%;
        .download-title {
          cursor: pointer;
          margin-top: 25px;
          text-decoration: underline;
          text-decoration-color: var(--bonus-txt);
          margin-bottom: 10px;
          &:first-child {
            margin-top: 0;
          }
        }
      }
      p {
        color: var(--bonus-txt);
      }
      .date {
        color: var(--red-txt);
      }
    }
    .download-button {
      display: flex;
      align-items: center;
      margin-top: 10px;
      .download-arrow {
        margin: 0 10px 0 -6px;
      }
      p {
        margin: 0;
        color: var(--bonus-txt);
        text-decoration: underline;
        text-decoration-color: var(--bonus-txt);
      }
    }
    &:hover {
      @media (min-width: 1024px) {
        .main-content {
          &::after {
            max-height: 300px;
            height: 100%;
            transition: 0.4s ease-in-out;
          }
        }
        .download-button {
          .download-arrow {
            path {
              fill: var(--red);
            }
          }
          p {
            color: var(--red);
            text-decoration-color: var(--red);
          }
        }
      }
    }
  }
}
</style>
